{
  "longPressMessage": "Zum Öffnen der Vorschau lange drücken"
}
